import React from 'react';
import StyledModal from 'src/components/Modal';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';

interface IPrivacyStatementModal {
  handleClose: () => void;
  show: boolean;
  termsOfUsePdfUrl: string;
}

const PrivacyStatementModal = ({
  handleClose,
  show,
  termsOfUsePdfUrl,
}: IPrivacyStatementModal) => {
  const { t } = useTranslation();

  return (
    <StyledModal
      size="lg"
      show={show}
      title={t<string>('components.privacy-modal.title')}
      handleClose={handleClose}
      titleIcon={<FontAwesomeIcon icon={['fas', 'info-circle']} />}
    >
      <Modal.Body>
        <h5>
          <b>{t<string>('components.privacy-modal.subtitle')}</b>
        </h5>
        <ul>
          <li>{t<string>('components.privacy-modal.bullet1')}</li>
          <li>{t<string>('components.privacy-modal.bullet2')}</li>
          <li>{t<string>('components.privacy-modal.bullet3')}</li>
          <li>{t<string>('components.privacy-modal.bullet4')}</li>
        </ul>
        <br />
        <h5>{t<string>('components.privacy-modal.detailed-regulations')}</h5>
        <a target="_blank" href={termsOfUsePdfUrl} rel="noopener noreferrer">
          <FontAwesomeIcon icon={['fal', 'external-link-alt']} />
          &nbsp; {t<string>('common.privacy')}
        </a>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} variant="primary">
          {t<string>('common.close')}
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
};

export default PrivacyStatementModal;
